import React from "react";
import { twMerge } from "tailwind-merge";
import { NoItems } from "@/app/(components)/Basic/NoItems";
import { ArtworkItem, Props as ArtworkProps } from "../ArtworkItem";
import { ImageOrientation, ShortNft } from "@/api/nfts/types";
import { User } from "@/api/users/types";

export interface Props {
  nfts: ShortNft[];
  className?: string;
  artist?: User;
  artistVisible?: boolean;
  priceVisible?: boolean;
  blockchainVisible?: boolean;
}

const ArtworkList = ({
  nfts,
  className,
  artist,
  artistVisible = true,
  priceVisible,
  blockchainVisible,
}: Props) => {
  let swap = false;

  const artworkItems = nfts?.map(
    (nft) =>
      ({
        image: {
          src: nft.thumbnail || nft.image,
          width: nft.imageWidth,
          height: nft.imageHeight,
          orientation: nft.imageOrientation,
          type: nft.mediaType,
          placeholder: nft.placeholder,
        },
        id: nft.id,
        name: nft.name,
        artist: artist || nft?.artist, //TODO: Fix this after migrating indexer
        marketplace: nft.marketplace,
        blockchain: blockchainVisible ? nft.blockchain : null,
        paymentErc20TokenAddress: priceVisible
          ? nft.paymentErc20TokenAddress
          : null,
        price: priceVisible ? nft.price : null,
      }) as ArtworkProps,
  );

  if (!artworkItems?.length) {
    return <NoItems message="No items to display" />;
  }

  return (
    <div className={twMerge("flex flex-col gap-y-20", className)}>
      {artworkItems.map((item, index) => {
        if (item.image.orientation != ImageOrientation.Landscape) swap = !swap;

        return (
          <ArtworkItem
            {...item}
            swap={
              item.image.orientation == ImageOrientation.Landscape
                ? false
                : swap
            }
            key={index}
            artistVisible={artistVisible}
          />
        );
      })}
    </div>
  );
};

export default ArtworkList;
